var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag"},[_c('h2',[_vm._v("学术拜访")]),_vm._v(" "),(!_vm.isChild)?_c('span',{staticClass:"note-s1"},[_vm._v(_vm._s(_vm.content))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }